import type { MinifiedTask, TaskCategory } from '@gcv/shared';

import type { GetAssigneesParams } from '../../tasks/components/tasks-modal.repo';

/** Which users and groups every subtask in a group may be reassigned to. */
export const getGroupedTaskAssigneeParams = (
  tasks: MinifiedTask[],
  taskCategory: TaskCategory | undefined,
  isExternal: boolean
): GetAssigneesParams => ({
  taskCategory,
  originalGroupIds: [
    ...new Set(
      tasks.flatMap((t) => [...(t.assigned_group_ids ?? []), ...(t.original_assigned_group_ids ?? [])])
    )
  ],
  originalUserIds: [
    ...new Set(
      tasks.flatMap((t) => t.original_assigned_user_ids ?? t.assigned_users?.map((u) => u.id!) ?? [])
    )
  ],
  isExternal
});
